import _ from 'lodash';
import { Fragment } from 'react';
import { withRouter } from 'react-router-dom';

import { Header } from './header_footer';
import { If } from './utilities';
import { canUseDOM } from '../helpers/dom';
import { connectLocation } from '../location/LocationConnectors';

export const NotSupported = connectLocation(
  withRouter(({ t, openLocationModal, location, match }) => (
    <>
      <Header
        menu
        hideSteps
        price=""
        wind_resistance="--"
        warranty="--"
        locationChange={openLocationModal}
        location={location}
      />
      <p>{t(`build_your_roof.not_supported_${_.get(match, 'params.what', 'generic')}`)}</p>
      <If condition={match.params.what === 'browser'}>
        <p>{t('build_your_roof.not_supported_supported_browsers')}:</p>
        <ul>
          <li>
            <a href="https://www.google.com/chrome/">Chrome</a>
          </li>
          <li>
            <a href="https://www.microsoft.com/en-us/edge">Edge</a>
          </li>
          <li>
            <a href="https://www.mozilla.org/en-US/firefox/">Firefox</a>
          </li>
          <li>
            <a href="https://www.apple.com/safari/">Safari</a>
          </li>
        </ul>
      </If>
      <If condition={match.params.what === 'contractors_only'}>
        <a href="/users/logout">{t('build_your_roof.logout')}</a>
      </If>
    </>
  ))
);

export const NotSupportedNavigator = withRouter(({ location, history }) => {
  if (location.pathname.includes('not-supported')) {
    return null;
  }
  const isIE11 = canUseDOM() && !!window.MSInputMethodContext && !!document.documentMode;

  if (isIE11) history.replace('not-supported/browser');

  return null;
});
